
export const FIRST_SCREEN_STATIC = {
    "ro": {
        "web.personalized.plan": "Obțineți o estimare a scorului TOEFL și un plan de învățare personalizat",
        "web.quiz.3min": "Chestionar de 3 minute",
        "web.profile.age": "Vârsta dvs.",
        "web.unlock.english.potential": "Pregătiți-vă pentru TOEFL",
        "screen.practice.guide.control.next": "Următorul",
        "web.toefl.changes.title": "Știați că TOEFL se schimbă în 2026?",
        "web.toefl.changes.learn.more": "Aflați mai multe",
        "web.toefl.changes.already.know": "Știu deja"
    },
    "ru": {
        "web.personalized.plan": "Получите оценку балла TOEFL и персональный план обучения",
        "web.quiz.3min": "Тест на 3 минуты",
        "web.profile.age": "Ваш возраст",
        "web.unlock.english.potential": "Подготовьтесь к TOEFL",
        "screen.practice.guide.control.next": "Далее",
        "web.toefl.changes.title": "Вы знали, что TOEFL меняется в 2026 году?",
        "web.toefl.changes.learn.more": "Узнать больше",
        "web.toefl.changes.already.know": "Я уже знаю"
    },
    "it": {
        "web.personalized.plan": "Ottenga una stima del punteggio TOEFL e un piano di apprendimento personalizzato",
        "web.quiz.3min": "Quiz di 3 minuti",
        "web.profile.age": "La Sua età",
        "web.unlock.english.potential": "Preparati per il TOEFL",
        "screen.practice.guide.control.next": "Avanti",
        "web.toefl.changes.title": "Sapeva che il TOEFL cambia nel 2026?",
        "web.toefl.changes.learn.more": "Scopra di più",
        "web.toefl.changes.already.know": "Lo so già"
    },
    "cs": {
        "web.personalized.plan": "Získejte odhad skóre TOEFL a personalizovaný studijní plán",
        "web.quiz.3min": "Tříminutový kvíz",
        "web.profile.age": "Váš věk",
        "web.unlock.english.potential": "Připravte se na TOEFL",
        "screen.practice.guide.control.next": "Další",
        "web.toefl.changes.title": "Věděli jste, že se TOEFL v roce 2026 mění?",
        "web.toefl.changes.learn.more": "Zjistit více",
        "web.toefl.changes.already.know": "Už vím"
    },
    "pt-BR": {
        "web.personalized.plan": "Obtenha uma estimativa da pontuação TOEFL e um plano de aprendizagem personalizado",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "Sua idade",
        "web.unlock.english.potential": "Prepare-se para o TOEFL",
        "screen.practice.guide.control.next": "Próximo",
        "web.toefl.changes.title": "Você sabia que o TOEFL está mudando em 2026?",
        "web.toefl.changes.learn.more": "Saiba mais",
        "web.toefl.changes.already.know": "Eu já sei"
    },
    "in": {
        "web.personalized.plan": "Dapatkan perkiraan skor TOEFL dan rencana belajar yang dipersonalisasi",
        "web.quiz.3min": "Kuis 3 menit",
        "web.profile.age": "Usia Anda",
        "web.unlock.english.potential": "Persiapkan diri Anda untuk TOEFL",
        "screen.practice.guide.control.next": "Berikutnya",
        "web.toefl.changes.title": "Tahukah Anda bahwa TOEFL berubah pada tahun 2026?",
        "web.toefl.changes.learn.more": "Pelajari lebih lanjut",
        "web.toefl.changes.already.know": "Saya sudah tahu"
    },
    "ja": {
        "web.personalized.plan": "TOEFLスコアの目安と、あなた専用の学習プランをお届けします",
        "web.quiz.3min": "3分クイズ",
        "web.profile.age": "ご年齢",
        "web.unlock.english.potential": "TOEFLの準備を始めましょう",
        "screen.practice.guide.control.next": "次のページ",
        "web.toefl.changes.title": "2026年にTOEFLが変わることをご存知ですか？",
        "web.toefl.changes.learn.more": "詳しく見る",
        "web.toefl.changes.already.know": "もう知っています"
    },
    "el": {
        "web.personalized.plan": "Αποκτήστε μια εκτίμηση της βαθμολογίας TOEFL και ένα εξατομικευμένο πλάνο μάθησης",
        "web.quiz.3min": "Τρίλεπτο τεστ",
        "web.profile.age": "Η ηλικία σας",
        "web.unlock.english.potential": "Προετοιμαστείτε για το TOEFL",
        "screen.practice.guide.control.next": "Επόμενο",
        "web.toefl.changes.title": "Γνωρίζατε ότι το TOEFL αλλάζει το 2026;",
        "web.toefl.changes.learn.more": "Μάθετε περισσότερα",
        "web.toefl.changes.already.know": "Το γνωρίζω ήδη"
    },
    "no": {
        "web.personalized.plan": "Få et estimat av TOEFL-poengsummen din og en personlig læreplan",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Forbered deg til TOEFL",
        "screen.practice.guide.control.next": "Neste",
        "web.toefl.changes.title": "Visste du at TOEFL endrer seg i 2026?",
        "web.toefl.changes.learn.more": "Les mer",
        "web.toefl.changes.already.know": "Jeg vet allerede"
    },
    "pl": {
        "web.personalized.plan": "Uzyskaj szacunkowy wynik TOEFL i spersonalizowany plan nauki",
        "web.quiz.3min": "3-minutowy quiz",
        "web.profile.age": "Państwa wiek",
        "web.unlock.english.potential": "Przygotuj się do TOEFL",
        "screen.practice.guide.control.next": "Dalej",
        "web.toefl.changes.title": "Czy wiedzieli Państwo, że TOEFL zmienia się w 2026 roku?",
        "web.toefl.changes.learn.more": "Dowiedz się więcej",
        "web.toefl.changes.already.know": "Już wiem"
    },
    "sv": {
        "web.personalized.plan": "Få en uppskattning av ditt TOEFL-resultat och en personlig studieplan",
        "web.quiz.3min": "3-minuters quiz",
        "web.profile.age": "Din ålder",
        "web.unlock.english.potential": "Förbered dig för TOEFL",
        "screen.practice.guide.control.next": "Nästa",
        "web.toefl.changes.title": "Visste du att TOEFL ändras 2026?",
        "web.toefl.changes.learn.more": "Läs mer",
        "web.toefl.changes.already.know": "Jag vet redan"
    },
    "tr": {
        "web.personalized.plan": "TOEFL puanınızın tahminini ve kişiselleştirilmiş bir öğrenme planı alın",
        "web.quiz.3min": "3 dakikalık test",
        "web.profile.age": "Yaşınız",
        "web.unlock.english.potential": "TOEFL'a hazırlanın",
        "screen.practice.guide.control.next": "Sonraki",
        "web.toefl.changes.title": "2026'da TOEFL'un değiştiğini biliyor muydunuz?",
        "web.toefl.changes.learn.more": "Daha fazla bilgi",
        "web.toefl.changes.already.know": "Zaten biliyorum"
    },
    "en": {
        "web.personalized.plan": "Get a TOEFL score estimate and a personalized learning plan",
        "web.quiz.3min": "3 minute quiz",
        "web.profile.age": "Your age",
        "web.unlock.english.potential": "Get ready for TOEFL",
        "screen.practice.guide.control.next": "Next",
        "web.toefl.changes.title": "Did you know TOEFL is changing in 2026?",
        "web.toefl.changes.learn.more": "Learn more",
        "web.toefl.changes.already.know": "I already know"
    },
    "fi": {
        "web.personalized.plan": "Hanki arvio TOEFL-pisteistäsi ja henkilökohtainen oppimissuunnitelma",
        "web.quiz.3min": "3 minuutin testi",
        "web.profile.age": "Ikäsi",
        "web.unlock.english.potential": "Valmistaudu TOEFL-testiin",
        "screen.practice.guide.control.next": "Seuraava",
        "web.toefl.changes.title": "Tiesitkö, että TOEFL muuttuu vuonna 2026?",
        "web.toefl.changes.learn.more": "Lue lisää",
        "web.toefl.changes.already.know": "Tiedän jo"
    },
    "fr": {
        "web.personalized.plan": "Obtenez une estimation de votre score TOEFL et un plan d'apprentissage personnalisé",
        "web.quiz.3min": "Quiz de 3 minutes",
        "web.profile.age": "Votre âge",
        "web.unlock.english.potential": "Préparez-vous pour le TOEFL",
        "screen.practice.guide.control.next": "Suivant",
        "web.toefl.changes.title": "Saviez-vous que le TOEFL change en 2026 ?",
        "web.toefl.changes.learn.more": "En savoir plus",
        "web.toefl.changes.already.know": "Je suis déjà au courant"
    },
    "es": {
        "web.personalized.plan": "Obtenga una estimación de su puntuación TOEFL y un plan de aprendizaje personalizado",
        "web.quiz.3min": "Cuestionario de 3 minutos",
        "web.profile.age": "Su edad",
        "web.unlock.english.potential": "Prepárese para el TOEFL",
        "screen.practice.guide.control.next": "Siguiente",
        "web.toefl.changes.title": "¿Sabía que el TOEFL cambia en 2026?",
        "web.toefl.changes.learn.more": "Más información",
        "web.toefl.changes.already.know": "Ya lo sé"
    },
    "nl": {
        "web.personalized.plan": "Ontvang een schatting van uw TOEFL-score en een gepersonaliseerd leerplan",
        "web.quiz.3min": "3 minuten quiz",
        "web.profile.age": "Uw leeftijd",
        "web.unlock.english.potential": "Bereid u voor op de TOEFL",
        "screen.practice.guide.control.next": "Volgende",
        "web.toefl.changes.title": "Wist u dat de TOEFL in 2026 verandert?",
        "web.toefl.changes.learn.more": "Meer informatie",
        "web.toefl.changes.already.know": "Ik weet het al"
    },
    "bg": {
        "web.personalized.plan": "Получете оценка на вашия резултат от TOEFL и персонализиран учебен план",
        "web.quiz.3min": "3-минутен тест",
        "web.profile.age": "Вашата възраст",
        "web.unlock.english.potential": "Подгответе се за TOEFL",
        "screen.practice.guide.control.next": "Следваща",
        "web.toefl.changes.title": "Знаехте ли, че TOEFL се променя през 2026 г.?",
        "web.toefl.changes.learn.more": "Научете повече",
        "web.toefl.changes.already.know": "Вече знам"
    },
    "nb": {
        "web.personalized.plan": "Få et estimat av TOEFL-poengsummen din og en personlig læreplan",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Forbered deg til TOEFL",
        "screen.practice.guide.control.next": "Neste",
        "web.toefl.changes.title": "Visste du at TOEFL endrer seg i 2026?",
        "web.toefl.changes.learn.more": "Les mer",
        "web.toefl.changes.already.know": "Jeg vet allerede"
    },
    "hi": {
        "web.personalized.plan": "अपना TOEFL स्कोर अनुमान और व्यक्तिगत लर्निंग प्लान प्राप्त करें",
        "web.quiz.3min": "3 मिनट का क्विज़",
        "web.profile.age": "आपकी आयु",
        "web.unlock.english.potential": "TOEFL की तैयारी करें",
        "screen.practice.guide.control.next": "अगला",
        "web.toefl.changes.title": "क्या आप जानते हैं कि 2026 में TOEFL बदल रहा है?",
        "web.toefl.changes.learn.more": "और जानें",
        "web.toefl.changes.already.know": "मुझे पहले से पता है"
    },
    "de": {
        "web.personalized.plan": "Erhalten Sie eine Schätzung Ihres TOEFL-Ergebnisses und einen personalisierten Lernplan",
        "web.quiz.3min": "3-Minuten-Quiz",
        "web.profile.age": "Ihr Alter",
        "web.unlock.english.potential": "Bereiten Sie sich auf den TOEFL vor",
        "screen.practice.guide.control.next": "Weiter",
        "web.toefl.changes.title": "Wussten Sie, dass sich der TOEFL 2026 ändert?",
        "web.toefl.changes.learn.more": "Mehr erfahren",
        "web.toefl.changes.already.know": "Ich weiß es bereits"
    },
    "ko": {
        "web.personalized.plan": "TOEFL 점수 예측과 맞춤형 학습 계획을 받아보세요",
        "web.quiz.3min": "3분 퀴즈",
        "web.profile.age": "귀하의 나이",
        "web.unlock.english.potential": "TOEFL을 준비하세요",
        "screen.practice.guide.control.next": "다음",
        "web.toefl.changes.title": "2026년에 TOEFL이 변경된다는 것을 알고 계셨나요?",
        "web.toefl.changes.learn.more": "자세히 알아보기",
        "web.toefl.changes.already.know": "이미 알고 있습니다"
    },
    "ar": {
        "web.personalized.plan": "احصل على تقدير لدرجة TOEFL وخطة تعلم مخصصة",
        "web.quiz.3min": "اختبار لمدة 3 دقائق",
        "web.profile.age": "عمرك",
        "web.unlock.english.potential": "استعد لاختبار TOEFL",
        "screen.practice.guide.control.next": "التالي",
        "web.toefl.changes.title": "هل تعلم أن اختبار TOEFL يتغير في عام 2026؟",
        "web.toefl.changes.learn.more": "اعرف المزيد",
        "web.toefl.changes.already.know": "أعرف ذلك بالفعل"
    },
    "pt": {
        "web.personalized.plan": "Obtenha uma estimativa da pontuação TOEFL e um plano de aprendizagem personalizado",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "A sua idade",
        "web.unlock.english.potential": "Prepare-se para o TOEFL",
        "screen.practice.guide.control.next": "Próximo",
        "web.toefl.changes.title": "Sabia que o TOEFL está a mudar em 2026?",
        "web.toefl.changes.learn.more": "Saiba mais",
        "web.toefl.changes.already.know": "Já sei"
    },
    "zh": {
        "web.personalized.plan": "获取您的 TOEFL 分数估算和个性化学习计划",
        "web.quiz.3min": "3分钟测验",
        "web.profile.age": "您的年龄",
        "web.unlock.english.potential": "准备好迎接 TOEFL 考试",
        "screen.practice.guide.control.next": "下一页",
        "web.toefl.changes.title": "您知道 TOEFL 将在 2026 年发生变化吗？",
        "web.toefl.changes.learn.more": "了解更多",
        "web.toefl.changes.already.know": "我已经知道了"
    },
    "uk": {
        "web.personalized.plan": "Отримайте оцінку вашого балу TOEFL та персоналізований план навчання",
        "web.quiz.3min": "3-хвилинний тест",
        "web.profile.age": "Ваш вік",
        "web.unlock.english.potential": "Підготуйтеся до TOEFL",
        "screen.practice.guide.control.next": "Далі",
        "web.toefl.changes.title": "Чи знали ви, що TOEFL змінюється у 2026 році?",
        "web.toefl.changes.learn.more": "Дізнатися більше",
        "web.toefl.changes.already.know": "Я вже знаю"
    }
}